export default __webpack_public_path__ + "254bedcf45384a07f18459c1c8ceda5b.svg";